import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GenericModalService, ModalState, ModalSettingsBase, ModalTypes } from './generic-modal.service';
import { ModalMessageComponent } from './modal-message.component';
import { ModalConfirmComponent } from './modal-confirm.component';
import { ModalConfirmMultiButtonComponent } from './modal-confirm-multi-button.component';
import { ModalSelectMultiChoiceComponent } from './modal-select-multi-choice.component';
import { ModalInputComponent } from './modal-input.component';
import { ModalFileSelectorComponent } from './modal-file-selector.component';
import { ModalChangePasswordComponent } from './modal-change-password.component';
import { ModalDateTime } from './modal-datetime.component';
import { ModalJsonViewerComponent } from './modal-json-viewer.component';

@Component({
    selector: 'ep-generic-modal-message',
    templateUrl: './generic-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ModalMessageComponent, ModalConfirmComponent, ModalConfirmMultiButtonComponent, ModalSelectMultiChoiceComponent, ModalInputComponent, ModalFileSelectorComponent, ModalChangePasswordComponent, ModalDateTime, ModalJsonViewerComponent]
})
export class GenericModalComponent implements OnInit {
    @ViewChild("modalMessage", { static: true }) modalMessage: TemplateRef<any>;
    @ViewChild("modalConfirm", { static: true }) modalConfirm: TemplateRef<any>;
    @ViewChild("modalConfirmMultiButton", { static: true }) modalConfirmMultiButton: TemplateRef<any>;
    @ViewChild("modalSelectMultiChoice", { static: true }) modalSelectMultiChoice: TemplateRef<any>;
    @ViewChild("modalInput", { static: true }) modalInput: TemplateRef<any>;
    @ViewChild("modalFile", { static: true }) modalFile: TemplateRef<any>;
    @ViewChild("modalChangePassword", { static: true }) modalChangePassword: TemplateRef<any>;
    @ViewChild("modalDateTime", { static: true }) modalDateTime: TemplateRef<any>;
    @ViewChild("modalJsonViewer", { static: true }) modalJsonViewer: TemplateRef<any>;

    constructor(private modal: NgbModal, private modalService: GenericModalService, private modalState: ModalState) {

    }

    ngOnInit() {

        this.modalService.messageEvent = (settings: ModalSettingsBase) => {
            this.modalState.options = settings;

            // Message dialog
            if (settings.modalType == ModalTypes.Message) {
                this.modalState.modal = this.modal.open(this.modalMessage, settings.generateNgbOptions());
            }

            // Confirm dialog
            if (settings.modalType == ModalTypes.Confirm) {
                this.modalState.modal = this.modal.open(this.modalConfirm, settings.generateNgbOptions());
            }

            // MultiButton dialog
            if (settings.modalType == ModalTypes.ConfirmMultiButton) {
                this.modalState.modal = this.modal.open(this.modalConfirmMultiButton, settings.generateNgbOptions());
            }

            // Select dialog
            if (settings.modalType == ModalTypes.SelectMultiChoice) {
                this.modalState.modal = this.modal.open(this.modalSelectMultiChoice, settings.generateNgbOptions());
            }

            // Input dialog
            if (settings.modalType == ModalTypes.Input) {
                this.modalState.modal = this.modal.open(this.modalInput, settings.generateNgbOptions());
            }

            // File dialog
            if (settings.modalType == ModalTypes.FileSelector) {
                this.modalState.modal = this.modal.open(this.modalFile, settings.generateNgbOptions());
            }

            if (settings.modalType == ModalTypes.ChangePassword) {
                this.modalState.modal = this.modal.open(this.modalChangePassword, settings.generateNgbOptions());
            }

            if (settings.modalType == ModalTypes.DateTime) {
                this.modalState.modal = this.modal.open(this.modalDateTime, settings.generateNgbOptions());
            }

            // Json Viewer
            if (settings.modalType == ModalTypes.JsonViewer) {
                this.modalState.modal = this.modal.open(this.modalJsonViewer, settings.generateNgbOptions());
            }

            return this.modalState.modal.result;
        };
    }
}